export function validateSelect(form){
    const inputGroups = form.querySelectorAll('.input-select')
    let errorEx = false
    if(inputGroups){
        inputGroups.forEach(inputGroup => {
            const result = inputGroup.querySelector('.result')
            const selSelector = inputGroup.querySelector('select')
            const error = inputGroup.querySelector('.errorSELmsj')
            if(result.value === '') {
                error.classList.add('active')
                inputGroup.classList.add('invalid')
                errorEx = true
            } else {
                error.classList.remove('active')
                inputGroup.classList.remove('invalid')
                errorEx = false
            }
        })
    }
    return errorEx
}

// import {validateSelect} from '@/js/components/validation/class/val_select'